/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Restore_Manual_EditsInputs */



/**
* | output |
* | --- |
* | "This also rewinds any edits you made yourself since then." |
*
* @param {Assistant_Restore_Manual_EditsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_restore_manual_edits = /** @type {((inputs?: Assistant_Restore_Manual_EditsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Restore_Manual_EditsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cela annule également toutes les modifications que vous avez effectuées vous-même depuis.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dadurch werden auch alle Änderungen rückgängig gemacht, die Sie seitdem selbst vorgenommen haben.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Questa operazione annulla anche tutte le modifiche apportate da te successivamente.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Это также отменяет все изменения, внесенные вами самостоятельно с тех пор.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Esto también revierte cualquier edición que hayas realizado desde entonces.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("这也会撤销你之后所做的任何编辑。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("これにより、それ以降にあなたが行った編集内容もすべて元に戻されます。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इससे आपके द्वारा बाद में किए गए सभी संपादन भी पूर्ववत हो जाते हैं।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Isso também reverte quaisquer edições que você tenha feito desde então.")
	return /** @type {LocalizedString} */ ("This also rewinds any edits you made yourself since then.")
});